<template>
  <div>
    <!-- Loader start-->
    <div v-if="card_list.length === 0">
      <v-btn color="#6dbe45" large style="width: 130px">
        <span class="spinner-border spinner-border-sm"></span>
        Loading...
      </v-btn>
    </div>
    <!-- Main Page starts here-->
    <div class="top" v-else>
      <BackButton />
      <h4 style="color: white; font-weight: bold; width: 90%; margin: auto">
        Best Container Prices For Delivery To {{ delivery_city }}
      </h4>
      <ul>
        <li v-for="(item, index) in card_list" :key="index" class="grow">
          <div :class="item">
            <v-flex pa-3>
              <v-card
                class="mx-auto pa3"
                color="gray lighten-4"
                style="width: 100%; border-radius: 10px; max-width: 280px"
                @click.prevent="
                  item.availableForSale ? addLineItem(item) : doNothingatClick()
                "
              >
                <img :src="item.image_url" width="250px" height="250px" />
                <v-card-text class="pt-4" style="position: relative">
                  <strong style="font-size: 18px">{{
                    item.container_size
                  }}</strong>
                  <p>
                    <span style="font-weight: bold"
                      >${{ item.container_price }}</span
                    >/mo
                  </p>
                  <p>
                    Shipping:
                    <span style="font-weight: bold"
                      >${{ formatNumber(item.hauling_price) }}</span
                    >
                    (delivery/pick-up combined)
                  </p>
                  <div class="unavailable" v-if="!item.availableForSale">
                    <v-btn
                      relative
                      color="#ffffff"
                      class="my-2 btns"
                      medium
                      style="color: #00587d; font-weight: bold"
                      >Out of Stock</v-btn
                    >
                  </div>
                  <div v-else>
                    <v-btn
                      relative
                      color="#00587d"
                      class="my-2 btns"
                      medium
                      style="color: #ffffff"
                      >Select&nbsp;
                      <v-icon small color="#ffffff"
                        >mdi-arrow-right-bold</v-icon
                      ></v-btn
                    >
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import * as types from "../store/types";
import BackButton from "./BackButton";

export default {
  name: "SelectContainers",
  components: {
    BackButton,
  },
  data() {
    return {
      delivery_city: "",
      card_list: [],
    };
  },
  computed: {
    ...mapGetters({
      VuexZipcode: types.ZIPCODE,
      VuexRentalContainersList: types.RENTALCONTAINERSLIST,
      VuexCartItem: types.CARTLINEITEM,
    }),
  },
  mounted() {
    window.scrollTo(0, 0);
    //Get the containers list from back-end if the VuexCartItem size is zero.
    if (this.VuexRentalContainersList) {
      this.delivery_city = this.VuexRentalContainersList.customerInfo.DeliveryCity;
      this.initializelist();
    } else this.$router.push("/");
  },
  methods: {
    ...mapActions({
      setVuexCartLineItem: types.ACTIONS_UPDATE_CARTLINEITEM,
    }),
    initializelist() {
      //Initialize the car list with products.
      const products = this.VuexRentalContainersList.products;
      var productKey;
      for (productKey in products) {
        this.card_list.push(products[productKey][0]);
      }
    },
    doNothingatClick() {
      return;
    },
    formatNumber(num) {
      if (num % 1 === 0)
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      else return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    addLineItem(lineItem) {
      //Add line item to cart.
      const item_attributes = {
        sellingPlanId: lineItem.sellingPlanId,
        variantId: lineItem.id,
        sku: lineItem.sku,
        container_price: lineItem.container_price,
        container_size: lineItem.container_size,
        market_city: lineItem.market_city,
        image_url: lineItem.image_url,
        hauling_price: lineItem.hauling_price,
        total_price: lineItem.total_price,
        market_code: lineItem.market_code,
        quantity: 1,
      };
      this.setVuexCartLineItem(item_attributes);
      this.maintainLocalStorageCart();
      this.$router.push("/rentals/cart");
    },
    maintainLocalStorageCart() {
      //Maintain local storage with cart line item.
      const cartItem = JSON.stringify(this.VuexCartItem);
      localStorage.setItem("cartItem", cartItem);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Material+Icons");

.top {
  margin: 0px auto;
  width: 100%;
  padding: 15px;
  text-align: center;
  margin-bottom: 60px;
}

.btns {
  margin: 35px;
  color: #ffffff;
  text-decoration: none;
  font-weight: 700;
  text-transform: unset !important;
  border-radius: 15px;
  box-shadow: 2px 1px 2px 3px #6dbe45;
}

.btns i {
  max-width: 0;
  transition: max-width 0.5s;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
}

.btns:hover i {
  max-width: 10rem;
  transition-delay: 0.1s;
}

.v-card p {
  font-size: 20px;
}

li {
  display: inline-block;
}

@media screen and (max-width: 411px) {
  v-card,
  img {
    width: 90%;
  }
  .top {
    width: 100%;
  }
}
</style>
